import { render, staticRenderFns } from "./VivoConsulta.vue?vue&type=template&id=5646defe&scoped=true&"
import script from "./VivoConsulta.vue?vue&type=script&lang=js&"
export * from "./VivoConsulta.vue?vue&type=script&lang=js&"
import style0 from "./VivoConsulta.vue?vue&type=style&index=0&id=5646defe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646defe",
  null
  
)

export default component.exports